import { render, staticRenderFns } from "./IsReadStatus.vue?vue&type=template&id=23309d6a&scoped=true&"
import script from "./IsReadStatus.vue?vue&type=script&lang=js&"
export * from "./IsReadStatus.vue?vue&type=script&lang=js&"
import style0 from "./IsReadStatus.vue?vue&type=style&index=0&id=23309d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23309d6a",
  null
  
)

export default component.exports